module.exports = "/_next/static/images/0c1bab4c1a0b608fcac8dd3727994720-challenge-system-large.jpg";